import { catchError, defaultIfEmpty, Observable, of, take } from "rxjs";
import { SimpleModalConfig } from "@app/shared/services/modal.service";

export const UNSAVED_EDITS_DIALOG: SimpleModalConfig = {
  title: "Unsaved changes",
  message: "Save before you leave, or discard the edits?",
  primaryButtonText: "Save & continue",
  secondaryButtonText: "Discard changes",
  showCloseButton: true,
};

/** What the user chose; closing the prompt without a choice means "stay". */
export type UnsavedEditsAnswer = "save" | "discard" | "stay";

export interface UnsavedEditsDialog {
  readonly config: SimpleModalConfig;
  readonly primary: UnsavedEditsAnswer;
  readonly secondary: UnsavedEditsAnswer;
}

export function unsavedEditsDialog(
  saveRefusal: string | null,
): UnsavedEditsDialog {
  if (saveRefusal === null) {
    return {
      config: UNSAVED_EDITS_DIALOG,
      primary: "save",
      secondary: "discard",
    };
  }
  return {
    config: {
      title: "Unsaved changes",
      message: `${saveRefusal} Discard the edits to leave, or stay to keep them on screen.`,
      primaryButtonText: "Discard and leave",
      primaryButtonVariant: "error",
      secondaryButtonText: "Stay",
      showCloseButton: true,
    },
    primary: "discard",
    secondary: "stay",
  };
}

/**
 * One modal answer as exactly one value. omniark's modal ERRORS its result
 * stream on Escape, backdrop and the close button, and a stream that errors
 * or completes empty would leave a route guard pending or throw a
 * NavigationError. `dismissed` is what both of those mean.
 */
export function answerOnce<T>(
  result$: Observable<T>,
  dismissed: T,
): Observable<T> {
  return result$.pipe(
    take(1),
    catchError(() => of(dismissed)),
    defaultIfEmpty(dismissed),
  );
}
